import React, { useState } from "react";
import DeviceContext from "../../../service/indentifyDevice";
import EdButton from "../../../generic/edButton";
import Search from "../../../generic/search";
import HoldFilter from "./holdFilter";
import NavigationTag from "../../../generic/navigationTag";
import { useRouteMatch } from "react-router-dom";
import { IHoldRouteParams } from "../../../types/components/holdings/holdTypes";
import NavigationDropdown from "../../../generic/navigationDropdown";
import "../../../../assets/scss/components/toc/orderBook/obContainer/obUtilHeader.scss";

export interface IHoldUtilHeaderProps {
	data: Array<Array<any>>; // data to be searched or filtered
	searchKey: string; // key on which search needs to be performed
	onDataFilter: (filteredData: any[], sText?: string, type?: string) => void; // returns filtered array after searching
	onToggleClick?: (groupedData: Array<Array<any>>, toggleState: boolean) => void; // event after clicking on filter button
	onSearchClick: (hidePriNav: boolean) => void; // event after clicking on search button
	defaultToggleState?: boolean;
}

export enum EHoldUtilHeaderState {
	NORMAL,
	FILTER,
	SEARCH
}

const HoldUtilHeader: React.FC<IHoldUtilHeaderProps> = props => {
	const [utilHeaderState, setUtilHeaderState] = useState(EHoldUtilHeaderState.NORMAL);
	const routeParams = useRouteMatch<IHoldRouteParams>();

	function onSearchClick(e: React.MouseEvent<HTMLButtonElement, MouseEvent>) {
		setUtilHeaderState(EHoldUtilHeaderState.SEARCH);

		props.onSearchClick(true);
	}

	function onCancelClick() {
		setUtilHeaderState(EHoldUtilHeaderState.NORMAL);
		props.onSearchClick(false);
		props.onDataFilter(props.data, "", "search");
	}

	function tagList() {
		return routeParams.url.indexOf("equity") !== -1
			? [
					{ value: "usable", display: "Usable", href: "usable" },
					{ value: "unusable", display: "Unusable", href: "unusable" },
					{ value: "smallcase", display: "Smallcase", href: "smallcase" }
			  ]
			: routeParams.url.indexOf("mf") !== -1
			? [
					{ value: "usable", display: "Usable", href: "usable" },
					{ value: "unusable", display: "Unusable", href: "unusable" }
			  ]
			: [];
	}

	return (
		<>
			{utilHeaderState === EHoldUtilHeaderState.NORMAL && (
				<div className="util_cont">
					<div>
						{!DeviceContext().isMobile ? (
							<NavigationTag defaultValue={routeParams.params.hold || "usable"} tagList={tagList()} onSelect={() => {}} />
						) : (
							<NavigationDropdown
								defaultValue={routeParams.params.hold || "usable"}
								dropdownOptions={tagList()}
								onSelect={() => {}}
								type="sec_nav"
							/>
						)}
					</div>

					<div className="utils">
						{props.data[0].length > 0 && props.onToggleClick && props.defaultToggleState !== undefined && (
							<span className="ib vMid">
								<HoldFilter data={props.data} tglClick={props.onToggleClick} defaultToggleState={props.defaultToggleState} />
							</span>
						)}
						{props.data[0].length > 0 && (
							<span className="ib vMid">
								<EdButton
									value={
										<>
											<i className="search edel-icon-search vTextTop btn_icon" />
											{!DeviceContext().isMobile && <span>Search</span>}
										</>
									}
									btnTyp="blue-link"
									onClick={onSearchClick}
									className="search_btn"
								/>
							</span>
						)}
					</div>
				</div>
			)}
			{utilHeaderState === EHoldUtilHeaderState.SEARCH && (
				<div className="util_cont search_active">
					{/* Search takes 1D array and returns 1D array
					So we need to convert it accordingly */}
					<Search searchList={props.data} searchKey={props.searchKey} onSearch={props.onDataFilter} classname="active" />
					<EdButton value="close" btnTyp="link" onClick={onCancelClick} />
				</div>
			)}
		</>
	);
};

export default HoldUtilHeader;
